@import '../../styles/palette.scss';
@import '../../styles/fonts.scss';

%triangleVertical {
  position: absolute;
  z-index: 9995;
  width: 0;
  height: 0;
  border-left: 1.25rem solid transparent;
  border-right: 1.25rem solid transparent;
}

.triangleUp {
  @extend %triangleVertical;
  border-bottom: 1.25rem solid _palette(text-secondary);
}

.triangleDown {
  @extend %triangleVertical;
  border-top: 1.25rem solid _palette(text-secondary);
}

.hoverCardWrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  outline: none;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto 0.5em auto 0.5em;

    &:not(.active) {
      color: _palette(text-secondary);
    }

    &.active {
      color: _palette(secondary);
    }
  }
}

.hoverCard {
  position: relative;
  z-index: 9999;
  min-width: 15rem;
  max-width: 20rem;
  max-height: 20rem;
  background-color: _palette(bg-secondary);
  border: 0.15rem solid _palette(text-secondary);
  color: _palette(secondary);
  border-radius: 5px;
  padding: 0.5em 1em 0.5em 1em;
  overflow: auto;
  line-height: 1.43;

  h3 {
    @include barlow(16, 600);
  }
  h4 {
    @include barlowMedium(14);
  }
  h5 {
    @include barlowMedium(12);
  }

  .address {
    width: 98%;
    border-top: 0.05em solid _palette(table-row-border);
    margin-top: 0.5em;
    padding-top: 0.25em;
  }

  .headings {
    width: 98%;
    border-top: 0.05em solid _palette(table-row-border);
    margin-top: 0.5em;
    padding-top: 0.25em;

    .placeLink {
      a {
        color: _palette(secondary) !important;
        text-decoration: none;
        word-wrap: break-word;

        &:hover,
        &:focus {
          text-decoration: underline;
        }
      }
    }

    h5:last-child {
      display: flex;
      color: _palette(primary);

      a {
        color: _palette(primary) !important;
      }

      &::before {
        display: inline-block;
        margin-right: 0.33em;
        transform: scaleX(-1);
        content: '↵';
      }
    }
  }

  .link {
    color: _palette(secondary) !important;
    word-wrap: break-word;
  }
}
